import { Container, Typography } from '@mui/material'
import { useDocumentTitle } from '../hooks/useDocumentTitle'

export const NotFound = ({ title = 'Not Found' }: { title?: string }) => {
  useDocumentTitle('Not Found')
  return (
    <Container maxWidth="sm">
      <Typography variant="h1" textAlign="center">
        {title}
      </Typography>
      <Typography variant="body1" textAlign="center">
        The page you are looking for does not exist.
      </Typography>
    </Container>
  )
}
